import React from "react";
import orderBy from "lodash/orderBy";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import WarehouseCard from "./WarehouseCard";

export default function SelectWarehouse({ modal, warehouses, changeWarehouse }) {
  const list = orderBy(warehouses || [], v => (v?.name || "").toLowerCase());

  return (
    <Box height="100%" minHeight="75vh" display="flex" flexDirection="column" px={2}>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography fontSize={22} fontWeight={500}>
          Select a Warehouse
        </Typography>
        <Typography mt={0.5} color="text.secondary" fontSize={14}>
          Choose a warehouse to view locations
        </Typography>
      </Paper>

      {list.length === 0 ? (
        <Paper
          sx={{
            py: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "text.secondary",
          }}
        >
          <Typography>No warehouses available.</Typography>
        </Paper>
      ) : (
        <Grid container spacing={2}>
          {list.map(warehouse => (
            <Grid
              key={warehouse.id}
              size={{ xs: 12, md: modal ? 12 : 6, lg: modal ? 12 : 4, xl: modal ? 12 : 3 }}
            >
              <WarehouseCard warehouse={warehouse} onSelect={changeWarehouse} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
